export * from './entry-page-template';
